import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MunicipalEntitiesService } from '@prodcard/core'
import { Ref, ref, watch } from 'vue'
import VAutocompleteServer from './VAutocompleteServer.vue'
import { TextFieldDensity, createCtx, handleError } from '../helpers'

interface MunicipalEntityForSelect {
  name: string
  id: string
}

interface Props {
  municipalEntitiesService: MunicipalEntitiesService
  modelValue?: string
  label?: string
  loading?: boolean
  disabled?: boolean
  readonly?: boolean
  density?: TextFieldDensity
  errorMessages?: string | readonly string[]
}

const count = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'VMunicipalEntitiesSelect',
  props: {
    municipalEntitiesService: {},
    modelValue: {},
    label: { default: 'Муниципальное образование' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    density: {},
    errorMessages: {}
  },
  setup(__props: any) {

const props = __props;



const municipalEntities: Ref<MunicipalEntityForSelect[]> = ref([])

const select = ref()
const loadDefaultME = ref(false)
const isLoadMoreItems = ref(true)
const from = ref(0)
const total = ref(0)
const updateMEList = (paging: { from: number; count: number }, filter?: { search?: string }, replace = false) => {
  handleError(async () => {
    const response = await props.municipalEntitiesService.findAll(createCtx(), {
      paging,
      filter,
    })

    const resultList = response.items.map(me => ({
      name: me.name,
      id: me.id,
    }))

    if (replace) {
      municipalEntities.value = resultList
    } else {
      municipalEntities.value.push(...resultList)
    }

    isLoadMoreItems.value = municipalEntities.value.length < response.total
    from.value += paging.count
    if (total.value !== response.total) total.value = response.total
  })
}

const updateSearchValue = (val: string) => {
  from.value = 0
  updateMEList({ from: from.value, count: count }, { search: val }, true)
}

const findDefaultMEById = (id: string) => {
  handleError(async () => {
    const me = await props.municipalEntitiesService.findById(createCtx(), id)
    if (me) {
      select.value = { name: me.name, id: me.id }
    }
  }, loadDefaultME)
}

watch(
  () => props.modelValue,
  val => {
    if (!val && select.value) {
      select.value = undefined
      from.value = 0
      updateMEList({ from: from.value, count: count }, {}, true)
      return
    }
    if (select.value || !val) return

    findDefaultMEById(val)
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VAutocompleteServer, {
    modelValue: select.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event?.id)))
    ],
    items: municipalEntities.value,
    isLoadMoreItems: isLoadMoreItems.value,
    label: _ctx.label,
    "item-title": "name",
    loading: loadDefaultME.value || _ctx.loading,
    disabled: loadDefaultME.value || _ctx.disabled,
    density: _ctx.density,
    readonly: _ctx.readonly,
    "error-messages": _ctx.errorMessages,
    "onUpdate:searchValue": updateSearchValue,
    onLoadMore: _cache[2] || (_cache[2] = search => updateMEList({ from: from.value, count: count }, { search }))
  }, null, 8, ["modelValue", "items", "isLoadMoreItems", "label", "loading", "disabled", "density", "readonly", "error-messages"]))
}
}

})